
export const common = {
  nav: {
    solutions: "Soluções",
    method: "Metodologia",
    contemplatedCards: "Cartas Contempladas",
    companies: "Corporate",
    contents: "Conteúdos",
    about: "Sobre",
    contact: "Contato",
    diagnostico: "Diagnóstico"
  },
  cta: {
    diagnosis: 'Agendar Diagnóstico Estratégico',
    whatsapp: 'WhatsApp: Falar com Especialista',
    primary: 'Agendar Diagnóstico Estratégico',
    secondary: 'WhatsApp: Falar com Especialista'
  },
  footer: {
    company: 'FGT Capital',
    location: 'São Paulo/SP – Brasil',
    contact: 'Contato',
    email: 'contato@fgt-capital.com',
    phone: '+55 11 93032-2408',
    solutions: 'Soluções',
    solutionItems: {
      acquisition: 'Aquisição Imobiliária',
      construction: 'Construção e Reforma',
      planning: 'Planejamento Patrimonial',
      corporate: 'Estruturação Empresarial',
      letters: 'Cartas Contempladas'
    },
    institutional: 'Institucional',
    institutionalItems: {
      method: 'Metodologia FGT',
      business: 'Corporate',
      content: 'Conteúdos',
      about: 'Sobre'
    },
    compliance: 'A contemplação não pode ser garantida. Não há promessa de rentabilidade fixa. Custos e condições (taxa de administração e fundos de reserva) variam conforme regulamento e administradora.',
    rights: '© 2025 FGT Capital. Todos os direitos reservados.',
    copyright: '© 2025 FGT Capital. Todos os direitos reservados.',
    privacy: 'Privacidade',
    terms: 'Termos'
  }
};
